import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b08700d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "report-submit" }
const _hoisted_2 = { class: "report-submit__content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "report-submit__content-title" }, "Отправить отчёт", -1))
const _hoisted_4 = { class: "report-submit__content-info" }
const _hoisted_5 = { class: "report-submit__footer" }

import { computed, PropType } from 'vue'
import { useRoute } from 'vue-router'
import { FSubmitReport } from '@/features/FSubmitReport'
import { ReportViewType } from '@/shared/types'


export default /*#__PURE__*/_defineComponent({
  props: {
  email: String,
  reportType: String as PropType<ReportViewType>,
},
  setup(__props) {



const route = useRoute()

const reportId = computed(() => Number(route.params.reportId))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("p", _hoisted_4, " Отчёт будет отправлен пациенту на эл. почту " + _toDisplayString(__props.email), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_unref(FSubmitReport), {
        "report-type": __props.reportType,
        "report-id": _unref(reportId)
      }, null, 8, ["report-type", "report-id"])
    ])
  ]))
}
}

})